import React from "react";

type Position = "top" | "bottom" | "left" | "right";

interface Props {
  text: string;
  position?: Position;
  children?: React.ReactNode;
}

const positionClasses: Record<Position, string> = {
  top: "bottom-full left-1/2 -translate-x-1/2 mb-2",
  bottom: "top-full left-1/2 -translate-x-1/2 mt-2",
  left: "right-full top-1/2 -translate-y-1/2 mr-2",
  right: "left-full top-1/2 -translate-y-1/2 ml-2",
};

export function InfoTooltip({ text, position = "top", children }: Props) {
  return (
    <span className="relative inline-flex items-center group">
      {children || (
        <svg
          className="w-3.5 h-3.5 text-text-muted cursor-help"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          strokeWidth={2}
        >
          <circle cx="12" cy="12" r="10" />
          <path d="M12 16v-4M12 8h.01" />
        </svg>
      )}
      <span
        className={`absolute z-50 w-56 px-3 py-2 text-body-sm text-text-primary bg-surface-600 border border-border rounded-lg shadow-lg opacity-0 pointer-events-none group-hover:opacity-100 transition-opacity duration-150 ${positionClasses[position]}`}
      >
        {text}
      </span>
    </span>
  );
}
